<div [ngStyle]="containerStyle">
  @if (settings.title.mode === 'text' && settings.title.text) {
    <div class="title" [style.color]="titleColor || null" [innerHTML]="renderedTitleHtml"></div>
  } @else if (settings.title.mode === 'logo' && settings.title.logoUrl) {
    <img [src]="settings.title.logoUrl" alt="" class="logo" />
  }
  <button
    type="button"
    [ngStyle]="closeButtonStyle"
    (mouseenter)="onCloseHoverEnter($event)"
    (mouseleave)="onCloseHoverLeave($event)"
    aria-hidden="true"
    tabindex="-1">
    &times;
  </button>
</div>
